import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import type { ElForm } from 'element-ui/types/form';
import Upload from '../upload/upload.vue';
import NewSelectSite from '../newSelectSIte';
import GoodsLink from '@/views/components/goodsLink/goodsLink.vue';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop } from '@/util';
import { LIVE_STATE } from '@/views/pages/editVideo/editVideo';
import validateParams from '@/library/utils/paramFilter';
import { EmpServiceAPIActions } from '@/services/empService';
import { appEnvConfig } from '@/configs/appConfigs';
import AddHotDialog from '@/views/components/shopAdvertisement/addhotDialog';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import { Functions } from '@/library/utils/functions';
const isset = QinggerLibUtils.isset;

interface treeSelectType {
	parentId?: number;
	sgId?: number;
	sgName?: string;
	pHeight?: number;
	pWidth?: number;
	showType?: number;
}

// 1）未开始；2）直播中；3）直播结束；4）活动过期；5）已下架；6）暂存；
export enum LIVE_EDIT_STATE {
	NO_START = 1,
	LIVE_ON,
	END,
	EXPIRED,
	LOWER,
	TEMP,
}

// 1期刊、2商品、3商品列表、4直播、5秒杀、6团购、7活动、8促销
export enum LINK_TYPE {
	QIKAN = 1,
	GOOD,
	GOODLIST,
	LIVE,
	KILL,
	GROUP,
	ACTIVE,
	PROMOTION,
	GOOD_GROUP,
	NEW_PROMOTION,
}

// 活动类型  	活动类型可能包括：1发售活动、2促销活动、3互动活动、4报名活动 9全部
export const linkTypes = [
	{ value: LINK_TYPE.QIKAN, label: '期刊' },
	{ value: LINK_TYPE.GOOD, label: '商品' },
	{ value: LINK_TYPE.GOODLIST, label: '商品分类' },
	{ value: LINK_TYPE.GOOD_GROUP, label: '商品组' },
	{ value: LINK_TYPE.LIVE, label: '直播活动' },
	{ value: LINK_TYPE.KILL, label: '秒杀活动' },
	{ value: LINK_TYPE.GROUP, label: '团购活动' },
	// { value: LINK_TYPE.ACTIVE, label: "活动" },
	{ value: LINK_TYPE.PROMOTION, label: '促销' },
	{ value: LINK_TYPE.NEW_PROMOTION, label: '促销' },
];

@Component({
	components: {
		Upload,
		GoodsLink,
		LinkForm,
	},
})
export default class AddAd extends Vue {
	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	curPage = '1'; // 1 促销活动(新装修的促销活动) 2 原促销活动
	/**
	 * 图片上传地址
	 * @type {string}
	 */
	public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	@Prop()
	value;

	@Prop()
	treeSelect: treeSelectType;

	@Prop()
	tableSelectId;

	@Prop()
	state;

	@Prop()
	openType;

	@Prop()
	isOpenAd;

	@Prop({ default: 0 })
	openCoupon: number;

	// 微页面Id
	@Prop({ default: 0 })
	pageId: number;

	$refs: {
		addForm: ElForm;
		linkForm: ElForm;
	};

	moment = moment;

	title = '追加广告';

	isSelectSite = false;

	// 长期有效
	longTerm = false;

	// 连接至选中的数据
	linkSelectData: any = {};

	// 商品分类
	connectedClass = [];

	// 是否有权限
	isDisabled = false;
	targetHeight = 0;

	form: {
		advEndTime: string | number;
		_date: any[];
		siteCodes: string[];
		advId: number;
		sgwpId: number;
		advPic: string;
		sgId: number;
		advName: string;
		advBeginTime: string | number;
		linkCodes?: string;
		linkDesc?: string;
		pushFrequency?: number;
		_linkDesc?: string;
		openType?: number;
		advLinkType?: 1 | 2;
		isDisplay?: number;
		linkList?: any[];
		pageId: number;
	} = {
			advId: 0,
			sgId: 1,
			sgwpId: 1,
			advName: '',
			_date: [],
			siteCodes: [],
			advBeginTime: '',
			advEndTime: '',
			advPic: '',
			advLinkType: 1,
			// @ts-expect-error
			openType: this.openType,
			pushFrequency: 1,
			linkList: [],
			pageId: 0,
		};

	oldLinkList = new Array(3).fill('');

	get siteCodes(): any[] {
		return this.form.siteCodes.map((i: any) => {
			if (typeof i === 'string') {
				return i;
			} else {
				return i.siteCode;
			}
		});
	}

	// 链接至的hover
	linkToHover = false;

	linkSelect = linkTypes;
	// 1）未开始；2）直播中；3）直播结束；4）活动过期；5）已下架；6）暂存；
	LiveStateText = {
		[LIVE_EDIT_STATE.NO_START]: '未开始',
		[LIVE_EDIT_STATE.LIVE_ON]: '直播中',
		[LIVE_EDIT_STATE.END]: '直播结束',
		[LIVE_EDIT_STATE.EXPIRED]: '活动过期',
		[LIVE_EDIT_STATE.LOWER]: '已下架',
		[LIVE_EDIT_STATE.TEMP]: '暂存',
	};

	public rules = {
		advName: [{ required: true, message: '请输入广告标题', trigger: 'blur' }],
		_date: [{ validator: this.v_date, trigger: 'change' }],
		advPic: [{ required: true, message: '请选择广告图片', trigger: 'blur' }],
		siteCodes: [{ required: true, message: '请选择适用网点', trigger: ['change', 'blur'] }],
	};

	v_date(rule, value, callback) {
		if (this.longTerm) {
			callback();
		}
		if (!value || !value[0] || !value[1]) {
			callback(new Error('请选择广告有效期'));
		} else {
			callback();
		}
	}

	onChooseSitePopShow = () => {
		this.isSelectSite = true;
	};

	// 直播状态 101: 直播中, 102: 未开始, 103: 已结束, 104: 禁播, 105: 暂停中, 106: 异常, 107: 已过期
	liveStateText = {
		[LIVE_STATE.LIVE_ON]: '直播中',
		[LIVE_STATE.NO_START]: '未开始',
		[LIVE_STATE.END]: '已结束',
		[LIVE_STATE.CLOSE]: '禁播',
		[LIVE_STATE.PAUSE]: '暂停中',
		[LIVE_STATE.ERROR]: '异常',
		[LIVE_STATE.EXPIRED]: '已过期',
	};

	/**
	 * 图片上传之前
	 * @param {ItemObject} file
	 * @return boolean
	 */
	public onBeforeUpload(file: ItemObject): boolean {
		const isJpg = file.type === 'image/jpeg';
		const isPng = file.type === 'image/png';
		const isGif = file.type === 'image/gif';
		const LtSize = file.size / 1024 <= 2048;
		if (!isJpg && !isPng && !isGif) {
			this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
		}
		if (!LtSize) {
			this.$message.error('上传图片大小不能超过 2M');
		}
		return (isJpg || isPng || isGif) && LtSize;
	}

	public onUploadImgSuccess(res) {
		this.form.advPic = res.content;
		this.targetHeight = res.content.height;
	}

	imgLoad(el) {
		this.targetHeight = el.target.height;
	}

	public uploadImgError() {
		this.$message.error('图片上传失败');
	}

	// 打开添加热区的弹窗
	openAddHotDialog() {
		AddHotDialog.open({
			img: this.form.advPic,
			treeSelect: this.treeSelect,
			hotList: this.form.linkList,
			state: this.state,
			form: this.form,
			openCoupon: this.openCoupon,
			empCode: this.$store.state.empCode,
		}).then((res) => {
			this.$set(this.form, 'linkList', res);
			this.oldLinkList[this.form.advLinkType] = res;
		}, noop);
	}

	/**
	 * 组件值改变
	 * @param linkType
	 * @param linkId
	 */
	onLinkComChange(val) {
		if (this.form.advLinkType === 1) {
			// this.form.linkList = [
			//   {
			//     linkType: linkType,
			//     linkId: linkId,
			//     linkDesc: selectDesc,
			//     hotPosition: {},
			//   },
			// ];
			this.oldLinkList[this.form.advLinkType] = [val];
		}
		// this.form.linkType = linkType;
		// this.form.linkId = linkId;
	}

	// 图片上传
	handleUploadSuccess(res) {
		this.form.advPic = res.content;
		this.$refs.addForm.validateField('advPic', noop);
	}

	deleteUploadImg() {
		this.form.advPic = '';
	}

	/**
	 * 取得组件中选择的网点列表
	 * @return null
	 */
	public confirmSelectSite(val) {
		this.form.siteCodes = val;
	}

	openSelectSiteDialog(readonly) {
		new NewSelectSite().open({ sgId: this.form.sgId, selectCodes: this.form.siteCodes, readonly: !!readonly }).then((res) => {
			console.log(res);

			this.form.siteCodes = res;
			this.$refs.addForm.validateField('siteCodes', noop);
		})
	}

	// 长期有效change
	handleLongTerm() {
		if (this.longTerm) {
			this.form._date = [];
		}
	}

	handleComfirm() {
		this.$refs.addForm.validate((res) => {
			if (res) {
				this.$refs.linkForm
					? (this.$refs.linkForm.$refs.form as ElForm).validate((result) => {
						if (result) {
							this.handleSave();
						}
					})
					: this.handleSave();
			}
		});
	}

	handleSave() {
		const loading = this.$loading({
			lock: true,
			text: '请稍等...',
			spinner: 'el-icon-loading',
			background: 'rgba(225,225,225,0.3)',
		});
		this.form.advBeginTime = moment(this.form._date[0]).unix();
		this.form.advEndTime = moment(this.form._date[1]).unix();
		this.form.siteCodes = this.form.siteCodes.map((i: any) => (typeof i === 'string' ? i : i.siteCode));
		if (this.form.advLinkType === 1) {
			this.form.linkList.map((v) => {
				delete v.hotPosition;
				// delete v.linkDesc;
				return v;
			});
		}
		this.form.linkList.map((v) => {
			delete v.productSort;
			return v;
		});

		const postParams = validateParams(this.form);
		if (this.longTerm) {
			postParams.advBeginTime = 0;
			postParams.advEndTime = 0;
		}
		IPSService.gsPropageateEdit({ postParams }).then(
			(res) => {
				this.$message.success(`${this.form.advId ? '编辑' : '新增'}成功`);
				this.handleClose();
				loading.close();
			},
			() => {
				this.$message.error(`${this.form.advId ? '编辑' : '新增'}失败`);
				loading.close();
			},
		);
	}

	handleClose() {
		this.$emit('input', false);
	}

	setSelectGoods() {
		let list = [];
		list = this.connectedClass
			.filter(i => i.list && i.list.length)
			.map((i) => {
				i.list.map((v) => {
					v.select = (this.form.linkList[0] ? `${this.form.linkList[0].linkId}` : this.form.linkCodes || '').split('_').join(',').split(',').includes(v.value_no);
					return v;
				});
				return i;
			})
			.filter((i) => {
				return i.list.some(v => v.select);
			});

		this.linkSelectData = list.map((i) => {
			return {
				attrCode: i.attrCode,
				attrName: i.attrName,
				checkAll: true,
				selectNames: i.list
					.filter(v => v.select)
					.map((v) => {
						return v.value_name;
					}),
				selectValues: i.list
					.filter(v => v.select)
					.map((v) => {
						return v.value_no;
					}),
			};
		});
	}

	async mounted() {
		// 获取商品列表
		this.connectedClass = await this.getAttributeList();
		if (this.tableSelectId) {
			const form: any = await IPSService.gsPropageateInfo({ postParams: { advId: this.tableSelectId } }).then(
				(res) => {
					return res;
				},
				() => {
					this.$message.error('获取广告详情失败');
				},
			);
			if (form.advBeginTime === 0 && form.advEndTime === 0) {
				this.longTerm = true;
				form.advBeginTime = '';
				form.advEndTime = '';
				form._date = [];
			} else {
				form.advBeginTime = form.advBeginTime * 1000;
				form.advEndTime = form.advEndTime * 1000;
				form._date = [form.advBeginTime, form.advEndTime];
			}
			this.form = form;
			this.oldLinkList[this.form.advLinkType] = this.form.linkList;
			this.isDisabled = !form.operAuthority;
			this.setSelectGoods();
		}

		this.form.sgId = this.treeSelect.parentId;
		this.form.sgwpId = this.treeSelect['sgwpId'];
		this.form.pageId = this.pageId;
	}

	/**
	 * 获取关联分类
	 */
	public getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			return isset(res, 'list') ? res.list : [];
		});
	}

	getState() {
		let state = this.state;
		if (this.form.linkList[0] && this.form.linkList[0].linkType === 12 && this.form.advId) {
			state = 3;
		}
		return state;
	}

	linkTypeChange(val) {
		this.form.linkList = this.oldLinkList[val] || [
			{
				linkType: '',
				linkId: '',
				linkDesc: '',
				// hotPosition: {}
				hotPosition: {
					x: 10,
					y: 10,
					height: 50,
					width: 50,
				},
			},
		];
	}

	get excludeContent() {
		return this.openCoupon ? [7, 14, 15, 16] : [7, 12, 14, 15, 16];
	}
}
